import { BotaoTestar } from "./BotaoTestar";
import { TIPOS_CANAL, type Canal, type TipoCanal } from "../../lib/config-alertas/tipos";
import { useTemPermissao } from "../../lib/auth/permissoes";

/*
 * Tabela de canais de notificação (FE-6a — Tela 6). Espelha a `<table>` de
 * `PaginaBancos`/`TabelaTrilha`: colunas Nome · Tipo (rótulo pt-BR) · Ativo
 * (Sim/Não) · Ações.
 *
 * Ações: "Editar" (gated por `configurar_alertas` — só quem configura edita) e
 * `<BotaoTestar>` (gated, internamente, por `testar_canal`). Estado vazio: um `<p>`.
 *
 * Componente de apresentação: recebe `canais` + `aoEditar`; o gate de escrita é
 * computado por hook NO CORPO (nunca dentro de `.map`). SÓ tokens CPMH.
 */

const ACAO_CONFIGURAR_ALERTAS = "configurar_alertas";

/** Rótulo pt-BR de cada tipo (a chave técnica nunca aparece sozinha). */
const ROTULO_TIPO: Record<TipoCanal, string> = TIPOS_CANAL.reduce(
  (mapa, opcao) => {
    mapa[opcao.valor] = opcao.rotulo;
    return mapa;
  },
  {} as Record<TipoCanal, string>,
);

interface TabelaCanaisProps {
  canais: Canal[];
  aoEditar: (canal: Canal) => void;
}

export function TabelaCanais({
  canais,
  aoEditar,
}: TabelaCanaisProps): JSX.Element {
  const podeConfigurar = useTemPermissao(ACAO_CONFIGURAR_ALERTAS);

  if (canais.length === 0) {
    return (
      <p className="font-corpo text-base text-off-black">
        Nenhum canal cadastrado.
      </p>
    );
  }

  return (
    <table className="w-full border-collapse font-corpo text-base text-off-black">
      <thead>
        <tr className="border-b border-platinum text-left">
          <th className="py-2 pr-4 font-subtitulo">Nome</th>
          <th className="py-2 pr-4 font-subtitulo">Tipo</th>
          <th className="py-2 pr-4 font-subtitulo">Ativo</th>
          <th className="py-2 pr-4 font-subtitulo">Ações</th>
        </tr>
      </thead>
      <tbody>
        {canais.map((canal) => (
          <tr key={canal.id} className="border-b border-platinum">
            <td className="py-2 pr-4">{canal.nome}</td>
            <td className="py-2 pr-4">{ROTULO_TIPO[canal.tipo]}</td>
            <td className="py-2 pr-4">{canal.ativo ? "Sim" : "Não"}</td>
            <td className="py-2 pr-4">
              <div className="flex items-center gap-4">
                {podeConfigurar && (
                  <button
                    type="button"
                    onClick={() => aoEditar(canal)}
                    className="text-flame hover:underline"
                  >
                    Editar
                  </button>
                )}
                <BotaoTestar canalId={canal.id} />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
